import React from 'react'

const NoMatch = () => {
  return (
    <div className='h-screen p-16 text-4xl font-bold uppercase'>Page not found</div>
  )
}

export default NoMatch